import { Vue, debounce } from './config'

if (document.getElementById('v-people')) {
    new Vue({
        el: '#v-people',
        components: {
        },
        data: {
            query: '',
            areaId: 0,
            areas: [],
            locationId: 0,
            locations: [],
            page: 0,
            perPage: 12,
            results: [],
        },
        watch: {
            areaId: function () {
                this.doSearch()
            },
            locationId: function () {
                this.doSearch()
            },
            query: debounce(function (q) {
                this.doSearch()
            }, 500)
        },
        computed: {
            displayPage() {
                return this.page + 1
            },
            pages() {
                return Math.ceil(this.results.length / this.perPage)
            },
            curPage() {
                return this.results.slice(this.page * this.perPage, (this.page * this.perPage) + this.perPage)
            },
        },
        methods: {
            doSearch() {
                var vm = this
                vm.doPost('/umbraco/api/people/search', {
                    query: vm.query,
                    areaId: vm.areaId,
                    locationId: vm.locationId
                }, (data) => {
                    vm.results = data
                })
            },
            setPage(p) {
                this.page = p
                window.scrollTo({ top: this.$el.offsetTop, behavior: 'smooth' })
            }
        },
        mounted() {
            var vm = this
            vm.doPost('/umbraco/api/people/getbusinessareas', null, (data) => {
                vm.areas = data
                if (vm.querystringObject.a) {
                    vm.areaId = parseInt(vm.querystringObject.a)
                }
            })
            vm.doPost('/umbraco/api/people/getlocations', null, (data) => {
                vm.locations = data
            })
            vm.doSearch()
        }
    })
}